import { Component, inject, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IFreeTrialTileInstance } from '../../../../interfaces/tiles/definitions/free-trial-tile-definition.interface';
import { resolveSiteAssetCssValue } from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-free-trial-tile',
  templateUrl: './free-trial-tile.component.html',
  styleUrls: ['./free-trial-tile.component.scss'],
})
export class FreeTrialTileComponent {
  @Input() tileInstance: IFreeTrialTileInstance;

  private readonly tenantService = inject(CurrentTenantService);

  freeTrial = this.tenantService.currentTenantData.autoTrialPeriod ?? 30;

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(
      this.tileInstance?.background ?? '',
      this.tenantService.currentTenantData?.primaryWebUrl ?? '',
    );
  }
}
